import React from 'react'
import { Path, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'

export default function IconShoppingBagFilled({
  size = 24,
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6V7H14L14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0392 4.21071 12.5305 4 12 4ZM16 7L16 6C16 4.93913 15.5786 3.92172 14.8285 3.17157C14.0783 2.42143 13.0609 2 12 2C10.9392 2 9.92175 2.42143 9.17161 3.17157C8.42146 3.92172 8.00003 4.93913 8.00003 6V7H6.33115M16 7H17.6699C18.1024 6.99997 18.5299 7.09345 18.9229 7.27405C19.316 7.45467 19.6653 7.71814 19.947 8.0464C20.2287 8.37467 20.436 8.75997 20.5549 9.17588C20.6737 9.59179 20.7012 10.0285 20.6354 10.456L19.3804 18.608C19.2351 19.5525 18.7564 20.414 18.0311 21.0362C17.3057 21.6583 16.3816 22.0002 15.426 22H8.57403C7.61857 22 6.69463 21.6579 5.96949 21.0357C5.2444 20.4136 4.76594 19.5525 4.62068 18.6082L3.36568 10.4562C3.29993 10.0286 3.32738 9.59179 3.44621 9.17588C3.56503 8.75997 3.77239 8.37467 4.05407 8.0464C4.33575 7.71814 4.68508 7.45467 5.07812 7.27405C5.47112 7.09345 5.89864 6.99997 6.33115 7"
        fill={props.color}
      />
    </Svg>
  )
}
